const view = "site-sections-planning";

export const siteSectionsPlanning = {
  view,
  toolbar: `${view}/toolbar`,
  legacyPlanningOverrideButton: `${view}/legacy-planning-override-button`,
  filters: {
    component: `${view}/filters`,
    searchInputText: `${view}/filters/search-input-text`,
  },
  planningRangeScaleButtonGroup: `${view}/planning-range-scale-button-group`,
  skeleton: `${view}/skeleton`,
  todayButton: `${view}/today-button`,
  selectAllCheckbox: `${view}/select-all-sections-checkbox`,
  siteName: `${view}/site-name`,
  siteNameLoader: `${view}/site-name-loader`,
  sectionNode: {
    selectSectionCheckbox: `${view}/section-node/select-section-checkbox`,
    sectionName: `${view}/section-node/section-name`,
    sectionChildrenCount: `${view}/section-node/section-children-count`,
    sectionCategory: `${view}/section-node/section-category`,
  },
  planningLegend: `${view}/planning-legend`,
};
